export default __webpack_public_path__ + "static/media/oscer-pres-falls.1fbb8ba8.svg";